// Format a date as 01 August 2025 (leading zero for day, full month, year, no comma)
export function formatDate(dateInput: string | Date): string {
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  if (isNaN(date.getTime())) return '';
  // Use 'en-GB' to avoid commas and get the desired format
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
} 